
import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";
import { findSummaryText } from "../loanDetailEditUtil";

import { rows } from "./section-loan-guaranty-rows";

const SHORTHAND_FIELD = "LoanGuaranty";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanGuaranty extends Component {
  drawDataGuaranty(data) {
    if (data.recourse) {
      if (data.recourse.guaranteeTypeId ||
        data.recourse.carveouts ||
        data.recourse.misc ||
        data.recourse.recourseCalculationMethod) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, modifySummaryText, eventHandlers, ...other } = this.props;
    const summaryText = findSummaryText(data, SHORTHAND_FIELD);

    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Guaranty",
            key: LOAN_SECTION_KEYS.GUARANTY,
            isTitleGroup: true,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.GUARANTY}`),
            hasSummaryText: true,
            summaryText,
            modifySummaryText: () => modifySummaryText(SHORTHAND_FIELD, summaryText),
            sections: [
              this.drawDataGuaranty(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.guaranty.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
